// Small defensive helpers for template/endorsement records on the admin page.

/**
 * Whether a template is treated as deprecated. Supports an explicit
 * `deprecated` flag and an `attributes.deprecated` fallback for data written
 * before the field exists.
 */
export const isDeprecated = (template) =>
  template?.deprecated === true ||
  template?.attributes?.deprecated === "true" ||
  template?.attributes?.deprecated === true;

/**
 * Read a request's linked template id defensively, since the API may serialize
 * either camelCase or snake_case.
 */
export const requestTemplateId = (request) =>
  request?.templateId ?? request?.template_id ?? null;
